export default {
    farm: {
      locationType: "Type d'Emplacement",
      viewLocation: "Voir l'Emplacement",
      Circular: "Circulaire",
      Polygon: "Polygone",
      cropName: "Nom de la culture",
      selectFarmToEnableCalenderView: 'Sélectionnez la ferme pour activer la vue du calendrier',
      streetNo: "Numéro de rue",
      UPDATEGEOFENCEFORTHISFARM: "Mettre à jour la géofence pour cette ferme",
      AddZonestothisfarm: "Ajouter des zones à cette ferme",
      ViewZonestothisfarm: "Voir les zones de cette ferme",
      personal: "Personnel",
      community: "Communauté",
      searchEvents: "Rechercher des événements",
      farmerId: "ID du fermier",
      farmAddress: "Adresse de la ferme",
      farmID: "ID de la ferme",
      farmIdPlaceHolder: "Entrez l'ID de la ferme",
      onTheFarm: "À la ferme",
      userRoles: "Rôles des utilisateurs",
      adduser: "Ajouter un utilisateur",
      addAuser: "Ajouter un utilisateur",
      uploadUsers: "Télécharger des utilisateurs",
      addNewUser: "Ajouter un nouvel utilisateur",
      selectDept: "Sélectionner un département",
      selectRole: "Sélectionner un rôle",
      editUser: "Modifier l'utilisateur",
      totalFarms: "Total des fermes",
      NoAnimalsRegisteredForthisFarm: "Aucun animal enregistré pour cette ferme",
      farmsPerPage: "Fermes par page",
      regularFarms: "Fermes régulières",
      farmRegisteredProducts: "Produits enregistrés à la ferme",
      searchByFarmNameAndId: "Rechercher par nom de ferme et ID",
      loadingProductsPleaseWait: "Chargement des produits... Veuillez patienter",
      farmName: "Nom de la ferme",
      nameOfTheFarm: "Nom de la ferme",
      farmLocation: "Emplacement de la ferme",
      productName: "Nom du produit",
      stockStatus: "Statut du stock",
      inStock: "En stock",
      searchByProductName: "Rechercher par nom de produit",
      productCategory: "Catégorie de produit",
      products: "Produits",
      farms: "Fermes",
      zones: "Zones",
      registerAfarm: "Enregistrer une ferme",
      govtRegistry: "Registre gouvernemental",
      cooperativeId: "ID de la coopérative/union",
      cooperativeName: "Nom de la coopérative/union",
      farmType: "Type de ferme",
      contractMating: "Accouplement contractuel",
      customization: "Personnalisation",
      recordsPerpage: "Enregistrements par page",
      restoreDefault: "Restaurer les valeurs par défaut",
      apply: "Appliquer",
      CommunityName: "Nom de la communauté",
      corporateName: "Nom de l'entreprise",
      corporateRegistrationNum: "Numéro d'enregistrement de l'entreprise",
      corporateMailingAddress: "Adresse postale de l'entreprise",
      communityName: "Nom de la communauté",
      searchState: "Rechercher par ID de ferme, registre gouvernemental, ID de coopérative, type de ferme, accouplement contractuel",
      farmOwner: "Propriétaire de la ferme",
      govRegistrationNo: "Numéro d'enregistrement gouvernemental",
      farmInformation: "Informations sur la ferme",
      ownershipType: "Type de propriété",
      farmLicenseInformation: "Informations sur la licence de la ferme",
      licenseNumber: "Numéro de licence",
      licenseExpiryDate: "Date d'expiration de la licence",
      regulatorName: "Nom du régulateur",
      regulatorRepresentativeName: "Nom du représentant du régulateur",
      farmLocationSize: "Emplacement et taille de la ferme",
      productionSystem: "Système de production",
      productionSystemNew: "Système de production",
      goals: "Objectif(s)",
      country: "Pays",
      state: "État",
      city: "Village/Ville/Commune",
      gpsLocation: "Localisation GPS",
      latitude: "Latitude",
      longitude: "Longitude",
      farmNumber: "Numéro de ferme",
      postal: "Code postal",
      houseNumber: "Numéro de maison",
      farmRegistration: "Enregistrement de la ferme",
      cancel: "Annuler",
      register: "Enregistrer",
      ok: "ok",
      totalFarmSize: "Taille totale de la ferme",
      farmGeographicLocation: "Emplacement géographique de la ferme",
      perimeterPointLongitude: "Longitude du point de périmètre",
      perimeterPointLatitude: "Latitude du point de périmètre",
      perimeterPointLabel: "Étiquette du point de périmètre",
      perimeterLength: "Longueur du périmètre",
      farmLatitude: "Latitude de la ferme",
      farmLongitude: "Longitude de la ferme",
      editFarm: "Modifier la ferme",
      update: "Mettre à jour",
      editAfarm: "Modifier une ferme",
      nextFarm: "Ferme suivante",
      nameoftheFarm: "Nom de la ferme",
      addNewLocation: "Ajouter un nouvel emplacement",
      registerAProduct: "Enregistrer un produit",
      farmProducts: "Produits de la ferme",
      calf: "Veau",
      steer: "Bœuf",
      heifer: "Génisse",
      sire: "Père",
      dam: "Mère",
      registerAnAnimal: "Enregistrer un animal",
      farmAnimals: "Animaux de la ferme",
      farm_type: "Type de ferme",
      farm_Owner: "Propriétaire de la ferme",
      dateOfRegistration: "Date d'enregistrement",
      dataIsNotAvailableForThisFarm: "Les données ne sont pas disponibles pour cette ferme",
      registerNewProduct: "Enregistrer un nouveau produit",
      information: "Informations",
      licenseInfo: "Informations sur la licence",
      locationInfo: "Informations sur l'emplacement",
      geoLocation: "Géolocalisation",
      perimeterLengthState: "Longueur du périmètre de la ferme (longueur de la clôture)",
      totalFarmSizeState: "Taille de la ferme",
      productionSystemState: "Système de production utilisé dans la ferme",
      contractMatingState: "Code du programme de reproduction contractuelle auquel la ferme participe.",
      ownershipTypeState: "Type de propriété",
      regulatorRepresentativeNameState: "Nom de la personne représentant le régulateur ayant délivré la licence",
      regulatorNameState: "Nom du régulateur ayant délivré la licence",
      licenseExpiryDateState: "Date d'expiration de la licence",
      licenseNumberState: "Numéro de la licence délivrée par le régulateur",
      plotNumberState: "Numéro de la maison de la ferme.",
      plotNumber: "Numéro de la ferme",
      streetStatement: "Nom de la rue de la ferme.",
      cityStatement: "Ville où se situe la ferme.",
      farmLocationAddressInfo: "L'endroit où la ferme exerce son activité agricole principale.",
      provinceStateInfo: "Une division administrative principale d'un pays ou d'un empire.",
      cityInfo: "Une agglomération humaine ou une communauté et ses bâtiments, plus grande qu'un hameau et plus petite qu'une ville, située dans une zone rurale.",
      streetNumberInfo: "Numéro de rue",
      totalFarmSizeInfo: "Taille totale de la ferme",
      areaUOMInfo: "L'unité de mesure de la taille de la ferme, par exemple, hectare, acre, etc.",
      perimeterLengthInfo: "Périmètre total de la ferme",
      permiterUOMInfo: "L'unité de mesure pour le périmètre de la ferme, par exemple, centimètre, mètre, etc.",
      stateStatement: "Région du pays où la ferme est située.",
      countryState: "Pays où la ferme est située.",
      farmStateInfo: "Adresse de localisation de la ferme",
      perimeterPointLongitudeState: "Longitude d'un point de la ferme.",
      perimeterPointLatitudeState: "Latitude d'un point de la ferme.",
      perimeterPointLabelState: "Étiquette du point.",
      farmLongitudeState: "Longitude de la ferme.",
      farmLatitudeState: "Latitude de la ferme.",
      deleteFarm: "Confirmation de suppression",
      confirmDeleteFarm: "Êtes-vous sûr de vouloir supprimer cette ferme ?",
      confirmBulkDeleteFarm:
        "Êtes-vous sûr de vouloir supprimer {count} ferme(s) sélectionnée(s) ?",
      selectFarmsToDelete: "Veuillez sélectionner au moins une ferme à supprimer.",
      bulkDeleted: "{count} ferme(s) ont été supprimée(s).",
      farmNameH: "Nom de la ferme",
      farmTypeH: "Le type de ferme où différentes activités sont menées.",
      farmOwnerH: "Nom du propriétaire d'une ferme (généré automatiquement en saisissant les informations du fermier)",
      ownershipTypeH: "Le type de fermiers qui possèdent/contrôlent la terre qu'ils cultivent et ceux qui ne le font pas.",
      govtRegNumbH: "Numéro d'enregistrement de la ferme attribué par le régulateur",
      contractMatingH: "Code du programme de reproduction contractuelle auquel la ferme participe",
      productionSystemH: "Le système de production utilisé à la ferme",
      cooperativeIDH: "ID de la coopérative à laquelle la ferme appartient",
      licenseNumberH: "Numéro d'identification sur une licence délivrée par le régulateur",
      licenseExpiryDateH: "Date d'expiration de la licence",
      regularNameH: "Nom du régulateur ayant délivré la licence",
      regularRepName: "Nom de la personne représentant le régulateur ayant délivré la licence",
      countryH: "Pays où la ferme est située.",
      stateH: "Région du pays où la ferme est située.",
      cityH: "Ville où la ferme est située.",
      streetH: "Nom de la rue de la ferme.",
      houseNumberH: "Numéro de la maison de la ferme.",
      totalFarmSizeH: "La taille de la ferme est la somme des terres actuellement cultivées par la ferme, y compris les terres en jachère mais à l'exclusion des terres sous végétation naturelle, arbres ou pâturages.",
      farmLatitudeH: "La mesure de la distance au nord ou au sud de l'équateur.",
      farmLongitudeH: "La mesure de la distance à l'est ou à l'ouest du méridien de Greenwich.",
      perimeterLengthH: "Longueur du périmètre de la ferme (longueur de la clôture)",
      perimeterPointLabelH:
        "Étiquette du point. En utilisant trois paramètres (latitude, longitude et étiquette), nous décrivons le périmètre de la ferme et tout segment à l'intérieur de la ferme.",
      perimeterPointLatH: "Latitude d'un point sur la ferme",
      perimeterPointLongH: "Longitude d'un point sur la ferme",
      street: "Rue",
      registration: {
        regulatorName: "Nom du régulateur ayant délivré la licence",
        perimeterPointLabel:
          "Étiquette du point. En utilisant trois paramètres (latitude, longitude et étiquette), nous décrivons le périmètre de la ferme et tout segment à l'intérieur de la ferme.",
        perimeterPointLatitude: "Latitude d'un point de périmètre",
        perimeterPointLongitude: "Longitude d'un point de périmètre",
        farmID: "Le numéro d'identification attribué à la ferme d'élevage",
        farmName: "Le nom donné à la ferme d'élevage",
        CommunityName:
          "Un nom donné à un groupe de personnes ayant une caractéristique ou un intérêt commun vivant ensemble au sein d'une société plus grande",
        farmType:
          "Le type de ferme peut être classé (groupé) en fonction du bétail cultivé et de la manière dont il est cultivé",
        farmOwner: "Toute personne qui possède ou contrôle les opérations d'une ferme",
        ownershipType:
          "Le type de fermiers qui possèdent/contrôlent la ferme et ceux qui ne le font pas",
        govtRegistrationNumber:
          "Numéro donné par l'organisation gouvernementale dans laquelle la ferme est enregistrée",
        licenseNumber: "Numéro de licence délivré par le régulateur",
        licenseExpiryDate: "Le jour où la licence devient invalide pour la reconnaissance",
        regulatorRepresentativeName: "Nom du représentant du régulateur",
      },
      addFarm: "Ajouter une ferme",
      importFarmsInBulk: "Importer des fermes en masse",
      importFarms: "Importer des fermes",
      importingNote:
        "Votre fichier téléchargé est en cours de traitement.\nNe cliquez pas sur annuler, ne fermez pas ni ne rafraîchissez pas cette page pour éviter toute interruption.",
      bulkImportNote:
        "Téléchargez et utilisez les modèles ci-dessous pour importer des fermes en masse.",
      importCompleted: "Importation terminée",
      importantNoteDetail:
        "Veuillez utiliser les modèles fournis ci-dessus pour les téléchargements en masse. D'autres formats entraîneront un échec.",
      farmerFirstName: "Prénom du fermier",
      farmerMiddleName: "Deuxième prénom du fermier",
      farmerLastName: "Nom de famille du fermier",
      iAmNotFarmer: "Je ne suis pas le fermier",
      certifications: "Certifications",
      productionType: "Type de production",
      deleted: "Ferme supprimée avec succès.",
      notDeleted: "Ferme non supprimée.",
      farmTitleDocument: "Documents de titre de la ferme",
      dropHere: "ou faites glisser et déposez ici",
      technicianName: "Nom du technicien",
      regBy: "Enregistré par",
      regDate: "Date d'enregistrement",
      farmRegistrationId: "ID d'enregistrement de la ferme",
      farmerRegistrationId: "ID d'enregistrement du fermier",
      farmId: "ID de la ferme",
      farmerName: "Nom du fermier",
      farmOwnershipType: "Type de propriété de la ferme",
      farmGoals: "Objectifs de la ferme",
      farmCertifications: "Certifications de la ferme",
      farmInfo: "Informations sur la ferme",
      provinceState: "Province/État",
      streetNumber: "Numéro de rue",
      addGeofenceForThisFarm: "Ajouter une géofence pour cette ferme",
      pleaseClickToChooseLocation: "Veuillez cliquer pour choisir l'emplacement",
      address: "Adresse",
      geographicLocation: "Emplacement géographique",
      searchLocation: "Rechercher un emplacement",
      pleaseChooseOneOfTheOption: "Veuillez choisir l'une des options",
      useGeoFencingFeature: "Utiliser la fonctionnalité de géofencing",
      uploadShapeFile: "Télécharger un fichier de forme",
      uploadGeofence: "Télécharger la géofence",
      upload: "Télécharger",
      reports: "Rapports",
      generateReport: "Générer un rapport",
      avocado: "Avocat",
      avocadoTrees: "Arbres à avocat",
      addNewFarmLocation: "Ajouter un nouvel emplacement de ferme",
      farmLocationAddress: "Adresse de l'emplacement de la ferme",
      useGeofenceTool: "Utiliser l'outil de géofencing",
      geofenceIsRequiredForSatelliteReport:
        "Remarque : La géofence est requise pour les rapports satellites",
      enterHere: "Entrez ici",
      primaryLocation: "Emplacement principal",
      secondaryLocation: "Emplacement secondaire",
      locationAndSize: "Emplacement et taille",
      farmReports: "Rapport(s) de la ferme",
      activities: "Activités",
      search: "Rechercher",
      selectCountry: "Sélectionner un pays",
      filterByFarmName: "Filtrer par nom de ferme",
      filterByCropType: "Filtrer par type de culture",
      filterByStartDate: "Filtrer par date de début",
      download: "Télécharger",
      of: "de",
      previousPage: "Page précédente",
      nextPage: "Page suivante",
      view: "Voir",
      activityDetails: "Détails de l'activité",
      activity: "Activité",
      cropType: "Type de culture",
      startDate: "Date de début",
      endDate: "Date de fin",
      description: "Description",
      close: "Fermer...",
      farmActivities: "Activités de la ferme",
      listView: "Vue en liste",
      calendarView: "Vue en calendrier",
      scheduledActivities: "Activités programmées",
      completedActivities: "Activités terminées",
      deforestationReports: "Rapport(s) sur la déforestation",
      id: "id",
      locationName: "Nom de l'emplacement",
      createdAt: "Créé à",
      etherScanLink: "Lien Blockchain",
      overallProb: "Probabilité globale",
      addNewZone: "Ajouter une nouvelle zone",
      noZoneMessage: "Aucune zone n'a encore été enregistrée.",
      noZoneRequest:
        "Veuillez cliquer sur Ajouter une nouvelle zone pour créer une zone pour cette ferme.",
      locationZone: "Zone d'emplacement",
      editFarmLocation: "Modifier l'emplacement de la ferme",
      addZone: "Ajouter une zone",
      nameOfTheZone: "Nom de la zone",
      zoneDetails: "Détails de la zone",
      perimeter: "Périmètre",
      areaUnit: "Unité de surface",
      area: "Surface",
      zoneName: "Nom de la zone",
      farmGeofence: "Géofence de la ferme",
      circularGeofence: "Géofence circulaire",
      polygonGeofence: "Géofence polygonale",
      radius: "Rayon",
      radiusInfo:
        "Précise la distance d'un point central vers le bord extérieur d'une zone circulaire.",
      radiusUnitInfo: "Fait référence à une quantité standard utilisée comme base de mesure.",
      actions: "Actions",
      editZone: "Modifier la zone",
      numberOfGroups: "Nombre de groupes",
      numberOfTrees: "Nombre d'arbres",
      group: "Groupe",
      groupName: "Nom du groupe",
      numberOfAnimals: "Nombre d'animaux",
      status: "Statut",
      primaryGeofence: "Géofence principale",
      walkAndMeasure: "Marcher et mesurer",
      clearGeofence: "Effacer la géofence",
      deleteSelectedVertex: "Supprimer le sommet sélectionné",
      basicInformation: "Informations de base",
      geofenceCategoryName: "Nom de la catégorie de géofence",
      geofenceName: "Nom de la géofence",
      farmRadius: "Rayon de la ferme",
      locationDisabledMessage:
        "Votre emplacement est désactivé. Veuillez rechercher votre emplacement dans les menus de gauche.",
      yourDistanceIs: "Votre distance est",
      selectFarmToEnableCalendarView:
        "Veuillez sélectionner une ferme pour activer la vue du calendrier",
      noFarm: "Aucune ferme n'a encore été enregistrée.",
      noFarmDescription:
        "Veuillez cliquer sur les boutons ci-dessous pour commencer.",
      searchFarmName: "Rechercher par nom de ferme",
      pleaseSelectFarmType: "Veuillez sélectionner le type de ferme.",
      organic: "Biologique",
      conventional: "Conventionnel",
      farmsAccessControl: "Contrôle d'accès aux fermes",
      chooseTheUserYouWantToManageFarmAccessFor: "Choisissez l'utilisateur (s) pour lequel vous souhaitez gérer l'accès à la ferme.",
      selectTheFarmYouWantToManageAccessFor: "Sélectionnez la ferme pour laquelle vous souhaitez gérer l'accès.",
      proceedWithSelected: "Procéder avec la sélection",
      userRole: "Rôle utilisateur",
      userRoleInfo: "Rôle utilisateur. Le rôle utilisateur détermine les permissions que l'utilisateur a sur la ferme.",
      usersSelected: "utilisateurs sélectionnés",
      viewFarmAccess: "Voir l'accès à la ferme",
      selectUser: "Sélectionner un utilisateur",
      recordsPerPage: "Enregistrements par page",
      print: "Imprimer",
      custom: "Personnalisé",
      records: "Enregistrements",
      dashboard: "Tableau de bord",
      accessControl: "Contrôle d'accès",
      all: "Tout",
      farmer: "Agriculteur",
      technician: "Technicien",
      userNameAndId: "Nom d'utilisateur et ID",
      email: "E-mail",
      userRoleAndRegDate: "Rôle utilisateur / Date d'enregistrement",
      access: "Accès",
      active: "Actif",
      inactive: "Inactif",
      na: "N/A",
      userDeactivated: "Utilisateur désactivé",
      userActivated: "Utilisateur activé",
      farmUsers: "Utilisateurs de la ferme",
      viewAndUpdateTheFarmsThisUserHasAccessTo: "Voir et mettre à jour les fermes auxquelles cet utilisateur a accès",
      assignFarmsToTheSelectedUsers: "Attribuer des fermes aux utilisateurs sélectionnés",
      selectTheFarmsYouWantToGrantAccessToForTheChosenTechnicians: "Sélectionnez les fermes auxquelles vous souhaitez accorder l'accès aux techniciens choisis.",
      removeAccessFromSelectedFarms: "Supprimer l'accès des fermes sélectionnées",
      grantFarmAccess: "Accorder l'accès à la ferme",
      back: "Retour",
      s: "(s)",
      loadingData: "Chargement des données...",
      areYouSureYouWantToGrantAccessTo: "Êtes-vous sûr de vouloir accorder l'accès à",
      areYouSureYouWantToRemoveAccessFrom: "Êtes-vous sûr de vouloir supprimer l'accès de",
      farmAccessRemoved: "Accès à la ferme supprimé",
      successfullyRemovedAccessFrom: "Accès supprimé avec succès de",
      failedToRemoveFarmAccessPleaseTryAgain: "Échec de la suppression de l'accès à la ferme. Veuillez réessayer.",
      forTheFollowingUsers: "pour l'utilisateur (s) suivant (s)?",
      selectFarm: "Sélectionner la ferme",
      grantAccess: "Accorder l'accès",
      removeAccess: "Supprimer l'accès",
      removeFarmAccess: "Supprimer l'accès à la ferme",
      farmAccessGranted: "Accès à la ferme accordé",
      successfullyGrantedAccessTo: "Accès accordé avec succès à",
      farm: "ferme",
      for: "pour",
      user: "utilisateur",
      failedToGrantFarmAccessPleaseTryAgain: "Échec de l'octroi de l'accès à la ferme. Veuillez réessayer.",
      error: "Erreur",
      selectFactory: "Sélectionner l'usine",
      failedToLoadFarmsPleaseTryAgain: "Échec du chargement des fermes. Veuillez réessayer.",
      farmNameAndId: "Nom et ID de la ferme",
      factory: "Usine",
      farmAddedBy: "Ferme ajoutée par",
      exportAsCSV: "Exporter en CSV",
      farmActivityLog: "Journal d'activité de la ferme",
      ipAddress: "Adresse IP",
      dateAndTime: "Date et heure",
      module: "Module",
      activityDescription: "Description de l'activité",
      select: "Sélectionner",
      activityLog: "Journal d'activité",


      youSharedAccessOfTheFarmWithTheFollowingUsersSuccessfully: "Vous avez partagé l'accès de la ferme avec le(s) utilisateur(s) suivant(s) avec succès.",
      grantAccessToMoreUsers: "Accorder l'accès à plus d'utilisateurs",
      areYouSureYouWantToRemoveAccessFor: "Êtes-vous sûr de vouloir supprimer l'accès pour",
      thisUser: "cet utilisateur",
      areYouSureYouWantToGrantAccessToThisFarmForTheFollowingUsers: "Êtes-vous sûr de vouloir accorder l'accès à cette ferme pour le(s) utilisateur(s) suivant(s)?",
      failedToLoadUsersPleaseTryAgain: "Échec du chargement des utilisateurs. Veuillez réessayer.",
      successfullyRemovedUserAccessFromThisFarm: "Accès utilisateur supprimé avec succès de cette ferme.",
      farmIdAndUserIdAreRequired: "L'ID de la ferme et l'ID de l'utilisateur sont requis.",
      noUsersSelectedPleaseSelectAtLeastOneUser: "Aucun utilisateur sélectionné. Veuillez sélectionner au moins un utilisateur.",
      successfullyGrantedAccessToThisFarmFor: "Accès accordé avec succès à cette ferme pour",
      unknownUser: "Utilisateur inconnu",
      confirm: "CONFIRMER",
      addNewUsers: "Ajouter de nouveaux utilisateurs",
      addUsersToFarm: "Ajouter des utilisateurs à la ferme",
      selectedUsers: "Utilisateurs sélectionnés",
      selectTheUsersToAddInFarmFromTheBelowListOfAllUserInACooperative: "Sélectionnez les utilisateurs à ajouter à la ferme dans la liste ci-dessous de tous les utilisateurs d'une coopérative.",
      reviewTheSelectedUsersAndAssignTheirAccessRoles: "Examinez les utilisateurs sélectionnés et attribuez leurs rôles d'accès.",
      allRoles: "Tous les rôles",
      userRegistrationDate: "Date d'enregistrement de l'utilisateur",
      deactivated: "Désactivé",
      pleaseSelectAtLeastOneUser: "Veuillez sélectionner au moins un utilisateur",
      noUsersSelected: "Aucun utilisateur sélectionné",
      userRemoved: "Utilisateur supprimé",
      next: "SUIVANT",
    },

    buySell: {
      farmerName: "Nom du fermier",
      location: "Emplacement",
      country: "Pays",
      gender: "Sexe",
      noOfOrdersSold: "Nombre de commandes vendues",
      noOfPurchaseOrders: "Nombre de commandes d'achat",
      totalPurchaseSaleVolume: "Volume total des ventes",
      totalAvgValue: "Valeur moyenne totale",
      searchOrderByID: "Rechercher une commande par ID",
      totalNumberofOrders: "Nombre total de commandes",
      totalNumberOfTransactions: "Nombre total de transactions",
      totalWeightOfTransactions: "Poids total des transactions",
      totalMonetaryValue: "Valeur monétaire totale",
      averagePrice: "Prix moyen",
    },

    farm_upload_validation: {
      Farm_Upload_Validation: "Validation de Téléchargement de la Ferme",
      Bulk_Upload_Field_Validation: "Validation des Champs de Téléchargement en Masse",
      Go_Back: "Retourner",
      Input_Field: "Champ de Saisie",
      Validation_Message: "Message de Validation",
      Description: "Description",
      Action: "Action",
      Validate: "Valider",
      Farm_Name: "Nom de la Ferme",
      Farm_Registration_ID: "ID d'Enregistrement de la Ferme",
      Farmer_First_Name: "Prénom de l'Agriculteur",
      Farmer_Last_Name: "Nom de Famille de l'Agriculteur",
      Farmer_Registration_ID: "ID d'Enregistrement de l'Agriculteur",
      User_Email_Address: "Adresse Email de l'Utilisateur",
      Shared_Access_With: "Partager l'Accès Avec",
      Ownership_Type: "Type de Propriété",
      Goal_s: "Objectif(s)",
      Production_Type: "Type de Production",
      Certifications: "Certifications",
      Total_Farm_Size: "Taille Totale de la Ferme (par exemple, 50 acres ou 20 hectares)",
      Farm_Address: "Adresse de la Ferme",
      Farm_GPS_Coordinates: "Coordonnées GPS de la Ferme (par exemple, 40.7128, -74.0060)",
      Country: "Pays",
      Province_State: "Province/État",
      Village_Town_City: "Village/Ville",
      Farm_Geofence: "Géofence de la Ferme (Polygone ou Cercle)",
      Helper_Messages: {
        Farm_Name: {
          Description: "Le nom officiel de la ferme tel qu'enregistré auprès des autorités ou connu publiquement.",
          Usage: "Ce nom est utilisé pour l'identification et le branding."
        },
        Farm_Registration_ID: {
          Description: "Un identifiant unique pour l'enregistrement de la ferme.",
          Assignment: "Attribué par un organisme gouvernemental ou agricole."
        },
        Farmer_First_Name: {
          Description: "Le prénom de l'agriculteur qui possède ou exploite la ferme.",
          Usage: "Utilisé pour l'identification personnelle et la documentation légale.",
          Instructions_1: "Entrez le prénom de l'agriculteur.",
          Instructions_2: "Évitez les abréviations, les chiffres ou les caractères spéciaux.",
          Instructions_3: "Si laissé vide, le système générera automatiquement 'Inconnu' comme prénom."
        },
        Farmer_Last_Name: {
          Description: "Le nom de famille (surnom) de l'agriculteur.",
          Usage: "Utilisé pour l'identification personnelle et la documentation légale.",
          Instructions_1: "Entrez le nom de famille de l'agriculteur.",
          Instructions_2: "Évitez les abréviations, les chiffres ou les caractères spéciaux.",
          Instructions_3: "Vérifiez que le nom de famille est inclus et correctement formaté.",
          Instructions_4: "Si laissé vide, le système générera automatiquement 'Inconnu' comme nom de famille."
        },
        Farmer_Registration_ID: {
          Description: "Un identifiant unique pour l'enregistrement de l'agriculteur.",
          Assignment: "Généralement attribué par un organisme de réglementation ou agricole.",
          Usage: "Utilisé pour l'enregistrement formel et la conformité.",
          Instructions_1: "Entrez l'ID d'enregistrement de l'agriculteur pour éviter les doublons.",
          Instructions_2: "Assurez-vous qu'il est unique et correctement formaté.",
          Instructions_3: "Si laissé vide, le système vous demandera de le fournir pour éviter de créer des entrées en double (non obligatoire)."
        },
        User_Email_Address: {
          Description: "Ceci est un email d'un utilisateur qui sera assigné à la ferme ou qui aura un accès principal à la ferme.",
          Context: "Cela pourrait être soit un agriculteur soit un technicien.",
          Usage: "Cet email est utilisé pour la communication, les notifications et la gestion des comptes.",
          Instructions_1: "Entrez un email valide (par exemple, exemple@domaine.com).",
          Instructions_2: "Vérifiez les fautes de frappe et les espaces.",
          Instructions_3: "Vérifiez que le format de l'email est correct.",
          Instructions_4: "Si laissé vide, le système devrait demander à l'utilisateur de fournir un email valide (non obligatoire)."
        },
        Shared_Access_With: {
          Description: "Spécifie les individus ou entités avec lesquels l'accès aux données de la ferme est partagé.",
          Usage: "Permet une collaboration contrôlée basée sur les rôles et les responsabilités."
        },
        Ownership_Type: {
          Description: "Indique le type de propriété de la ferme.",
          Examples: "Exemples incluent individuel, partenariat ou société.",
          Usage: "Utilisé à des fins légales et administratives."
        },
        Goal_s: {
          Description: "Décrit les principaux objectifs de la ferme."
        },
        Production_Type: {
          Description: "Indique l'activité agricole principale de la ferme, telle que biologique ou conventionnelle."
        },
        Certifications: {
          Description: "Sélectionnez les certifications liées à la ferme, telles que la certification biologique, le commerce équitable ou GAP."
        },
        Total_Farm_Size: {
          Description: "Superficie totale de la ferme (acres ou hectares). Utilisé pour la planification des ressources, les rapports réglementaires et l'analyse du marché."
        },
        Farm_Address: {
          Description: "Entrez l'adresse complète de la ferme, y compris l'adresse de la rue, la ville, l'état et le code postal. Utilisé pour l'identification de l'emplacement et la livraison des services."
        },
        Farm_GPS_Coordinates: {
          Description: "Coordonnées géographiques (latitude et longitude) de l'emplacement de la ferme. Aide à localiser la ferme sur une carte."
        },
        Country: {
          Description: "Le pays où se trouve la ferme."
        },
        Province_State: {
          Description: "La province ou l'état où se trouve la ferme. Les options dépendent du pays sélectionné."
        },
        Village_Town_City: {
          Description: "Le village, la ville ou la commune où se trouve la ferme."
        },
        Farm_Geofence: {
          Description: "La cartographie géofencing de la ferme comprend les limites de la ferme sur une carte. Définit la limite de la ferme à l'aide d'un géofencing (polygone ou cercle)."
        }
      },
      validation: {
        farmNameRequired: "Le nom de la ferme est requis",
        farmNameMaxLength: "Le nom de la ferme doit comporter moins de 50 caractères",
        farmNameExists: "Le nom de la ferme existe déjà",
        registrationIDRequired: "L'ID d'enregistrement est requis",
        registrationIDMaxLength: "L'ID d'enregistrement doit comporter moins de 20 caractères",
        firstNameRequired: "Le prénom de l'agriculteur est requis",
        firstNameLettersOnly: "Le prénom doit contenir uniquement des lettres",
        lastNameRequired: "Le nom de famille de l'agriculteur est requis",
        lastNameLettersOnly: "Le nom de famille doit contenir uniquement des lettres",
        emailRequired: "L'email est requis",
        emailValid: "Entrez un email valide (par exemple, exemple@domaine.com)",
        emailNoSpaces: "L'email ne doit pas contenir d'espaces",
        sharedAccessWithRequired: "Veuillez sélectionner au moins une entité ou laisser vide",
        ownershipTypeRequired: 'Le type de propriété est requis ou sera par défaut "Inconnu"',
        farmGoalsMaxLength: "Les objectifs de la ferme doivent comporter moins de 500 caractères",
        productionTypeRequired: "Veuillez sélectionner un type de production ou laisser vide",
        certificationsRequired: "Veuillez sélectionner au moins une entité ou laisser vide",
        farmSizePositive: "La taille de la ferme doit être une valeur numérique positive",
        farmSizeUnit: "Spécifiez l'unité (par exemple, 50 acres ou 20 hectares)",
        farmAddressFormat: "Adresse invalide. Format : Rue, Ville, État, Code postal",
        farmGPSCoordinatesFormat: "Coordonnées GPS invalides. Format : Latitude, Longitude (par exemple, 40.7128, -74.0060)",
        countryRequired: "Le pays est requis",
        countryLettersOnly: "Le nom du pays doit contenir uniquement des lettres",
        provinceStateRequired: "La province/l'état est requis(e)",
        provinceStateLettersOnly: "La province/l'état doit contenir uniquement des lettres",
        villageTownCityRequired: "Le village/la ville est requis(e)",
        villageTownCityLettersOnly: "Le village/la ville doit contenir uniquement des lettres",
        farmGeofencePolygon: "Points de polygone invalides. Format : Paires de latitude, longitude",
        farmGeofenceCircle: "Géofence invalide. Format : Latitude, Longitude du centre ; Surface en hectares"
      }
    },
    
    plantation: {
      farmerName: "Nom du fermier",
      phoneNumber: "Numéro de téléphone",
      plantationName: "Nom de la plantation",
      farm: "Ferme",
      location: "Emplacement",
      updatePlantationStatus: "Mettre à jour le statut de la plantation",
      update: "METTRE À JOUR",
      plantationStatus: {
        pending: "En attente",
        approved: "Approuvé",
        rejected: "Rejeté",
        completed: "Terminé",
      },
    },
    
}